/**
 * LocationModal Component
 * Interactive modal popup displaying location details, addresses, and embedded Google Maps
 * directions for the Clipstone Miners Welfare facilities (Welfare Building, Sports Building, Activity Hub).
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the location modal is visible
 * @param {Function} props.onClose - Modal close handler
 * @param {string} [props.initialCategory='community'] - Initially selected location tab
 */

import React, { useState } from 'react';

// Location details and Google Maps query metadata map
const locationPlaces = {
  community: {
    label: 'Clipstone Welfare Building',
    address: 'Mansfield Road, Clipstone NG21 9AL',
    description: 'Main welfare trust building for our sub-groups and trust-run social, sport and friendship activities.',
    query: 'Clipstone Welfare Building, Clipstone, UK'
  },
  sports: {
    label: 'Sports Building',
    address: 'Clipstone Sports Field, Clipstone NG21 9AL',
    description: 'Sports venue for training, matches and group physical activities.',
    query: 'Clipstone Sports Building, Clipstone, UK'
  },
  activities: {
    label: 'Activity & Charity Hub',
    address: 'Mansfield Road, Clipstone NG21 9AL',
    description: 'Charity and activity sessions are held at the Clipstone Welfare building in Clipstone.',
    query: 'Clipstone Welfare Building, Clipstone, UK'
  }
};

function LocationModal({ isOpen, onClose, initialCategory }) {
  const [locationCategory, setLocationCategory] = useState(initialCategory || 'community');

  if (!isOpen) return null;

  const getEmbedMapUrl = () => {
    return `https://maps.google.com/maps?q=${encodeURIComponent(locationPlaces[locationCategory].query)}&t=&z=14&ie=UTF8&iwloc=&output=embed`;
  };

  return (
    <div className="location-modal-overlay" onClick={onClose}>
      <div className="location-modal" onClick={e => e.stopPropagation()}>
        <button type="button" className="location-modal-close" onClick={onClose}>×</button>
        <div className="location-modal-header">
          <h2>Location finder</h2>
          <p>Select a category to see where that building is and open it in Google Maps.</p>
        </div>

        <div className="location-options">
          <button 
            className={`location-tab ${locationCategory === 'community' ? 'active' : ''}`} 
            onClick={() => setLocationCategory('community')}
          >
            Our Sub-Groups
          </button>
          <button 
            className={`location-tab ${locationCategory === 'sports' ? 'active' : ''}`} 
            onClick={() => setLocationCategory('sports')}
          >
            Sports
          </button>
          <button 
            className={`location-tab ${locationCategory === 'activities' ? 'active' : ''}`} 
            onClick={() => setLocationCategory('activities')}
          >
            Activities
          </button>
        </div>

        <div className="location-card">
          <div className="location-card-header">
            <div>
              <h3>{locationPlaces[locationCategory].label}</h3>
              <p className="location-description">{locationPlaces[locationCategory].description}</p>
              <p className="location-address" style={{ marginTop: '12px' }}>{locationPlaces[locationCategory].address}</p>
            </div>
          </div>
          
          <div className="location-map-container" style={{ marginTop: '20px' }}>
            <iframe
              title="Location Map"
              width="100%"
              height="300"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src={getEmbedMapUrl()}
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationModal;
